<template lang="pug">
    .reserve
        .body(v-loading="loading" :class="{ 'is-empty': ! loading && (! purchases || ! purchases.length) }")
            //- .under-construction
            //-     i.el-icon-fa-snowplow.fas
            //-     h4 {{ $t('Under Construction') }}
            //-     p {{ $t('Come back another time') }}
            .tab-content.scroll-box.pending-purchases.reservation(v-dragscroll)
                .empty(v-if="! loading && (! purchases || ! purchases.length)")
                    //- i.el-icon-fa-ghost.fas
                    .icon
                        i.el-icon-fa-slash.fas
                        i.el-icon-fa-circle.far
                    h4 {{ $t('Empty List') }}
                    p {{ $t('There is nothing to see here!') }}
                transition-group(v-else name="slide-decent-vertical" tag="div")
                    section.purchase(v-for="purchase in purchases" :key="purchase.id")
                        //- p {{ activeStock }}
                        //- p {{ activePointOfSale }}
                        .head
                            nobr.nr {{ purchase.id }}
                            nobr.name {{ purchase.purchaser.name }}
                            nobr.date {{ purchase.created_at | timestamp2date(dateTimeFormat) }}
                            nobr.grand-total {{ purchase.grand_total | moneyFormat(purchase.currency) }}
                        .items
                            template(v-for="item in purchase.items")
                                .stock-item(v-for="stock in item.stocks" :key="`${item.id}:${stock.id}`")
                                    item-media-preview(:item="item")
                                    .info
                                        .row
                                            nobr.nr {{ item.product_nr }}
                                            nobr.name {{ item.name }}
                                            nobr.price {{ item.sale_price || item.price | moneyFormat(purchase.currency) }}
                                        .row.properties
                                            property-value(
                                                v-for="property in item.properties.filter(el => el.selectable === true || el.article_required === true)"
                                                :key="property.id"
                                                :property="property"
                                            )
                                        .row
                                            nobr.sku
                                                label {{ $t('SKU') }}:
                                                span.value {{ item.sku }}
                                            nobr.stock
                                                label {{ $t('Stock') }}:
                                                span.value {{ stock.name }}
                                            nobr.qty
                                                label {{ $t('Quantity') }}:
                                                span.value {{ stock.pivot.qty }}
                                    //- .actions.done(v-if="stock.pivot.pointOfSale && stock.pivot.pointOfSale.id === activePointOfSale.id && stock.pivot.status && stock.pivot.status.key === 'reserved'")

                                    .actions.done(v-if="((stock.pivot.pointOfSale && stock.pivot.pointOfSale.id === activePointOfSale.id ) || (stock.id === activeStock.id)) && stock.pivot.status && stock.pivot.status.key === 'reserved'")
                                        el-button(
                                            plain
                                            size="small"
                                            type="info"
                                            icon="el-icon-fa-check fas"
                                            :loading="item.unreserving"
                                            :disabled="item.loading"
                                            @click="unmarkAsReserved(item, stock)"
                                        ) {{ $t('reserved') }}
                                    .actions.done(v-else-if="stock.pivot.pointOfSale && stock.pivot.pointOfSale.id === activePointOfSale.id && stock.pivot.status && stock.pivot.status.key === 'missing'")
                                        el-button(
                                            plain
                                            size="small"
                                            type="info"
                                            icon="el-icon-fa-times fas"
                                            :loading="item.unmissing"
                                            :disabled="item.loading"
                                            @click="unmarkAsMissing(item, stock)"
                                        ) {{ $t('missing') }}
                                    .actions(v-else)
                                        el-button(
                                            size="small"
                                            type="success"
                                            icon="el-icon-fa-check fas"
                                            :loading="item.reserving"
                                            :disabled="item.loading"
                                            @click="markAsReserved(item, stock)"
                                        ) {{ $t('reserve') }}
                                        el-button(
                                            size="small"
                                            type="danger"
                                            icon="el-icon-fa-times fas"
                                            :loading="item.missing"
                                            :disabled="item.loading"
                                            @click="markAsMissing(item, stock, purchase)"
                                        ) {{ $t('missing') }}
        .foot
            .actions
                .placeholder.gray-box.grow
                el-button.action(
                    plain
                    type="primary"
                    icon="el-icon-fa-print fas"
                    :loading="printing"
                    :disabled="loading || ! purchases || ! purchases.length"
                    @click="print"
                )

        el-dialog(
            :title="$t('How many are available?')"
            :visible.sync="modal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="580px"
            @closed="resetModal"
        )
            el-form.item-modal-form.stock-item(
                v-if="modal.form"
                :model="modal"
                label-position="top"
                :rules="modal.rules"
                ref="modal"
                v-loading="modal.loading"
                @submit.prevent.native="submitModalForm"
            )
                .info
                    .row
                        nobr.nr {{ modal.form.item.product_nr }}
                        nobr.name {{ modal.form.item.name }}
                        nobr.price {{ modal.form.item.sale_price || modal.form.item.price | moneyFormat(modal.form.purchase.currency) }}
                    .row.properties
                        property-value(
                            v-for="property in modal.form.item.properties.filter(el => el.selectable === true || el.article_required === true)"
                            :key="property.id"
                            :property="property"
                        )
                    .row
                        nobr.sku
                            label {{ $t('SKU') }}:
                            span.value {{ modal.form.item.sku }}
                        nobr.stock
                            label {{ $t('Stock') }}:
                            span.value {{ modal.form.stock.name }}
                        //- nobr.qty
                            label {{ $t('Quantity') }}:
                            span.value {{ modal.form.stock.pivot.qty }}
                //- .input-fields
                    el-input-number(
                        size="large"
                        v-model="modal.form.stock.pivot.qty_limit"
                        :min="0"
                        :max="modal.form.stock.pivot.qty - 1"
                        :step-strictly="true"
                    )
            template(slot="footer")
                .modal-footer(v-if="modal.form")
                    .left
                        el-input-number(
                            size="large"
                            v-model="modal.form.stock.pivot.qty_limit"
                            :min="0"
                            :max="modal.form.stock.pivot.qty - 1"
                            :step-strictly="true"
                        )
                    .right
                        el-button(
                            size="mini"
                            icon="el-icon-fa-times fas"
                            @click="closeModal"
                        ) {{ $t('Dismiss') }}
                        el-button(
                            :disabled="modal.loading || modal.saving"
                            size="mini"
                            type="primary"
                            icon="el-icon-fa-check fas"
                            @click="submitModalForm"
                        ) {{ $t('Save') }}
</template>

<i18n>
{
    "de": {
        "SKU": "SKU",
        "Quantity": "Anzahl",
        "Stock": "Lager",
        "reserve": "reservieren",
        "reserved": "reserviert",
        "missing": "fehlt",
        "Empty List": "Leere Liste",
        "There is nothing to see here!": "Hier gibt es nichts zu sehen!",
        "This item could not be reserved.": "Dieser Artikel konnte nicht reserviert werden.",
        "This item could not be unreserved.": "Die Reservierung dieses Artikels konnte nicht aufgehoben werden.",
        "This item could not be missing.": "Dieser Artikel konnte nicht als fehlend markiert werden.",
        "This item could not be unmarked as missing.": "Die \"fehlt\" Markierung dieses Artikels konnte nicht aufgehoben werden.",
        "How many are available?": "Wieviele sind verfügbar?",
        "Could not print the list!": "Liste konnte nicht gedruckt werden!"
    }
}
</i18n>

<script>
import printJS from 'print-js-updated'
import { timestamp2date } from '@/filters'

import PointOfSaleApi from '@/extensions/shop/pointOfSale/store/api/pointOfSale'

import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'
import ItemMediaPreview from '@/extensions/shop/pointOfSale/views/Partials/ItemMediaPreview'
import { usePosSetupStore } from '@/stores'

export default {
    name: 'Reserve',
    data: () => ({
        printing: false,
        modal: {
            visibility: false,
            loading: false,
            saving: false,
            submit: false,
            error: false,
            form: undefined,
            rules: {},
        }
    }),
    props: {
        context: {
            type: String,
            required: true,
        }
    },
    components: {
        PropertyValue,
        ItemMediaPreview,
    },
    filters: {
        timestamp2date,
    },
    // watch: {
    //     activePointOfSale(fresh, old) {
    //         if (! old || old.id !== fresh.id) {
    //             this.fetchPendingReservationPurchases({ pointOfSaleID: this.activePointOfSale.id, skip: 0, take: 10 })
    //         }
    //     },
    // },
    computed: {
        posSetupStore() {
            return usePosSetupStore()
        },
        dateTimeFormat() {
            const template = this.$t('yyyy-MM-dd')
            return `${template}, HH:mm`
        },
        loading() {
            return this.posSetupStore.loadingPendingReservationPurchases
        },
        purchases() {
            return this.posSetupStore.pendingReservationPurchasesItems
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale
        },
        activeStock() {
            return this.posSetupStore.activeStock
        }
    },
    methods: {
        markAsReserved(item, stock) {
            this.posSetupStore.markPurchasedItemAsReserved({ item, stock, pivotID: stock.pivot.id })
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('This item could not be reserved.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        },
        unmarkAsReserved(item, stock) {
            this.posSetupStore.unmarkPurchasedItemAsReserved({ item, stock, pivotID: stock.pivot.id })
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('This item could not be unreserved.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        },
        markAsMissing(item, stock, purchase) {
            stock = _.cloneDeep(stock)

            if (stock.pivot.qty <= 1) {
                stock.pivot.qty_limit = 0
                this.posSetupStore.markPurchasedItemAsMissing({ item, stock, pivotID: stock.pivot.id })
                    .catch(err => {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('This item could not be missing.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
            } else {
                // dialog: ask for qty_limit

                stock.pivot.qty_limit = stock.pivot.qty - 1
                this.modal.visibility = true
                this.posSetupStore.updateAutofocusSearchInput(false)
                this.$emit('blur-search')
                this.modal.form = { stock, item, purchase }
            }
        },
        unmarkAsMissing(item, stock) {
            this.posSetupStore.unmarkPurchasedItemAsMissing({ item, stock, pivotID: stock.pivot.id })
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('This item could not be unmarked as missing.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        },
        resetModal() {
            this.modal = {
                visibility: false,
                title: undefined,
                loading: false,
                saving: false,
                submit: false,
                error: false,
                form: undefined,
                rules: {},
            }
            this.posSetupStore.updateAutofocusSearchInput(true)
        },
        submitModalForm() {
            this.modal.saving = true

            const { item, stock } = this.modal.form
            this.posSetupStore.markPurchasedItemAsMissing({ item, stock, pivotID: stock.pivot.id })
                .then(this.closeModal)
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('This item could not be missing.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
                .finally(() => {
                    this.modal.saving = false
                })
        },
        closeModal() {
            this.modal.visibility = false
            this.posSetupStore.updateAutofocusSearchInput(true)
        },
        print() {
            // TODO: test
            this.printing = true;
            const printable = PointOfSaleApi.pendingReservationPurchasesRenderingUrl(this.activePointOfSale.id, 'preview');
            printJS({
                printable,
                onLoadingEnd: () => {
                    // Don't reset state here - wait for print dialog
                },
                onError: () => {
                    this.printing = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Could not print the list!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                },
                onPrintDialogClose: () => {
                    this.printing = false;
                }
            })
        }
    },
    mounted() {
        // if (this.activePointOfSale && this.activePointOfSale.id) {
        //     this.fetchPendingReservationPurchases({ pointOfSaleID: this.activePointOfSale.id, skip: 0, take: 10 })
        // }
        this.$emit('focus-search')
    }
}
</script>

<style lang="sass" scoped>

.pending-purchases
    flex-direction: column
    & > .el-loading-mask
        position: fixed
        // width: calc(50% - 56px)
        // left: calc(50% + 56px)
        // top: 123px
        // height: 100%
        width: 50%
        left: 50%
        top: 62px
        bottom: 0

    .purchase
        & + .purchase
            margin-top: 2rem
            // &:before
            //     content: ''
            //     display: block;
            //     width: 100%;
            //     margin-bottom: 2rem;
            //     height: 12px;
            //     background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='20' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25 1c-5 0-5 10-10 10S10 1 5 1 0 11-5 11-10 1-15 1' stroke='%23CBD5DF' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='square'/%3E%3C/svg%3E");

        .head
            // padding: 6px 12px
            padding: 6px 0
            // background: rgba(140, 147, 157, 0.2)
            // border-radius: 1rem
            margin-bottom: 0.5rem
            // display: flex
            // justify-content: space-between
            display: grid
            grid-template-columns: max-content auto max-content min-content
            gap: 1rem
            .grand-total
                text-align: right
                min-width: 80px
            .capture
                display: flex
                align-items: center

    .stock-item, .modal-item
        display: flex
        label
            font-weight: bold
        .info
            flex-grow: 1
            min-width: 0
            padding: 6px 0
        .actions
            display: flex
            gap: 0.25rem
            flex-direction: column
            justify-content: space-around
            // flex-basis: 100px
            min-width: 120px
            // margin-right: -6px
            .el-button
                margin-left: 0
            &.done
                justify-content: space-between
                .el-button
                    flex-grow: 1
                    // border-radius: 0.8rem
        .row
            display: flex
            gap: 0.5rem
            & + .row
                margin-top: 0.25rem
        .name
            flex-grow: 1
            min-width: 0
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
        .sku
            flex-grow: 1

    label + span.value:before
        content: ' '

    label
        font-style: italic
        &.small
            font-size: 0.8em

    .stock-item
        gap: 12px
        // padding: 6px 12px
        // padding-right: 6px
        padding: 6px
        // background: rgb(220, 221, 223, 0.5)
        background: rgba(255,255,255, 0.4)
        // border-radius: 1rem
        border-radius: 4px
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.04), 0 3px 1px -2px rgba(0,0,0,0.02), 0 1px 5px 0 rgba(0,0,0,0.1)
        & + .stock-item
            margin-top: 0.5rem
        & > .info
            display: flex
            flex-direction: column
            & > .row.properties
                flex-grow: 1

    .modal-item + .modal-item
        margin-top: 1rem
        border-top: 1px solid #dcdfe6
        padding-top: 1rem
.shop-tabs .stock-item
    background: #fbfbfb
.tab-content
    width: 100%
    display: flex
    flex-direction: column

.body
    min-height: 10rem
    position: relative
    flex-grow: 1
    /* overflow-x: hidden */
    /* overflow-y: auto */
    /* max-height: 100% */
    /* max-height: calc(100vh - 140px) */
    .scroll-box
        padding: 1rem
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        // height: calc(100% - 2px)
        overflow-x: hidden
        overflow-y: auto

.item-modal-form.stock-item
    background: yellow
    padding: 0
    border: 0
    box-shadow: none
    display: block
    .input-fields
        padding-top: 2rem
        // display: flex
        // flex-direction: column
        // align-items: center
.modal-footer
    display: flex
    justify-content: space-between
    align-items: flex-end
    .left
        display: flex
        align-items: flex-start
        ::v-deep input.el-input__inner
            font-weight: 900

.pending-purchases.reservation
    display: flex
    flex-direction: column
    gap: 0.5rem
.foot
    padding: 1rem
    display: grid
    gap: 0.5rem
    grid-template-rows: 50px
    grid-template-columns: repeat(12, minmax(0, 1fr))
    .gray-box
        height: 50px
        background: darken($color-skeleton, 10%)
        padding: 4px 1rem
        padding-bottom: 6px
        border-radius: 4px
        &.placeholder
            // background: darken($color-skeleton, 5%)
    .actions
        grid-column: 1 / -1
        display: flex
        gap: 0.5rem
        .grow
            flex-grow: 1
        .action
            font-size: 1.4rem
            &::v-deep > i.el-icon-loading
                width: 1.4rem
                height: 1.4rem
                &:after
                    width: 1.4rem
                    height: 1.4rem
                    left: calc(50% - 0.7rem)
                    top: calc(50% - 0.7rem)

// .scroll-box
//     position: absolute
//     left: -1rem
//     top: -1rem
//     right: -1rem
//     bottom: 0.5rem
//     max-height: calc(100vh - 64px)
//     padding: 1rem
//     overflow-x: hidden
//     overflow-y: auto

// .under-construction
//     flex-grow: 1
//     display: flex
//     flex-direction: column
//     justify-content: center
//     align-items: center
//     padding: 4rem
//     text-align: center
//     i
//         font-size: 4rem
//         color: rgba(0,0,0,0.2)
//     h4
//         margin-top: 1rem
//         margin-bottom: 0
//         font-size: 2rem
//         font-weight: 300
//         color: rgba(0,0,0,0.3)
</style>
